// extracted by mini-css-extract-plugin
export default {"SelectingPaymentMethodStageView":"SelectingPaymentMethodStageView_SelectingPaymentMethodStageView__gSsZy"};